import * as React from "react";

function ReprovisionIcon(props) {
    return (
        <span className="anticon iiht-sidebar-icons ant-menu-item-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width={19} height={19} viewBox="0 0 24 24" {...props}>
                <path fill="#3c4252" d="m18 20l-.707.707l.707.707l.707-.707zM13 4a1 1 0 1 0 0 2zm.293 12.707l4 4l1.414-1.414l-4-4zm5.414 4l4-4l-1.414-1.414l-4 4zM19 20V9h-2v11zM14 4h-1v2h1zm5 5a5 5 0 0 0-5-5v2a3 3 0 0 1 3 3zM6 4l.707-.707L6 2.586l-.707.707zm5 16a1 1 0 1 0 0-2zm-.293-12.707l-4-4l-1.414 1.414l4 4zm-5.414-4l-4 4l1.414 1.414l4-4zM5 4v11h2V4zm5 16h1v-2h-1zm-5-5a5 5 0 0 0 5 5v-2a3 3 0 0 1-3-3z" />
            </svg>
        </span>
    );
}

export default ReprovisionIcon;
